exports = module.exports = require("./../../../node_modules/custom-react-scripts/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3s6FTgA0XDxUIJ87mT0izn{font-size:1em!important;margin-right:.2em;color:inherit!important}._2s8Pt2WCgfVOejOlKRHiWM{margin-right:.5em}", ""]);

// exports
exports.locals = {
	"answerIcon": "_3s6FTgA0XDxUIJ87mT0izn",
	"headerIcon": "_2s8Pt2WCgfVOejOlKRHiWM"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/custom-react-scripts/~/css-loader?modules&-autoprefixer&importLoaders=1!./~/custom-react-scripts/~/postcss-loader!./src/components/recycling/style.css
 ** module id = 351
 ** module chunks = 0
 **/